module.exports = __webpack_public_path__ + "img/pyramid-five.74721566.svg";